import * as React from 'react';
import Modal from '../modal';
import { Query, QueryCondition, QueryFilter } from '../../api/apiTypes';

interface NumberRangeFilterModalProps {
    header: string;
    show: boolean;
    from: string;
    to: string;
    onClose: (event?) => void;
    onChange: (from, to, event?) => void;
    onClear?: () => void;
}

interface GenericNumberRangeFilterModalProps {
    query: Query<any>;
    member: string;
    header: string;
    onClose: (values: QueryFilter[]) => void;
    onClear: (member: string) => void;
}

export const GetQueryFilter = (query: Query<any>, member: string, condition: QueryCondition): QueryFilter => {
    return query.Filters.find(filter => filter.Member === member && filter.Condition === condition);
}

export default class NumberRangeModal extends React.Component<NumberRangeFilterModalProps> {
    render() {
        const { header, show, onClose, onChange, onClear, ...props } = this.props;
        const from = props.from ? props.from : "";
        const to = props.to ? props.to : "";
        const handleClose = (event?) => onClose(event);
        const handleChange = (from, to, event?) => { onChange(from, to, event); };
        const handleFromChange = (event) => handleChange(event.target.value, to, event);
        const handleToChange = (event) => handleChange(from, event.target.value, event);
        const handleClear = onClear ? onClear : (event?) => {
            handleChange("", "", event);
            handleClose(event);
        };

        return <Modal show={show} closeModalHandler={handleClose} header={header}>
            <div className='modal-body'>
                <div className='row'>
                    <div className='col-md-6 form-group'>
                        <label>From</label>
                        <input onChange={handleFromChange} className='form-control' value={from} />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label>To</label>
                        <input onChange={handleToChange} className='form-control' value={to} />
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='btn btn-primary' onClick={handleClose}>OK</button>
                <button className='btn btn-danger' onClick={handleClear}>Clear</button>
            </div>
        </Modal>
    }
}

export const GenericNumberRangeModal = ({ query, member, header, onClose, onClear }: GenericNumberRangeFilterModalProps): JSX.Element => {

    const fromFilterValue = GetQueryFilter(query, member, QueryCondition.GreaterThanOrEqual) || { Values: [] };
    const toFilterValue = GetQueryFilter(query, member, QueryCondition.LessThanOrEqual) || { Values: [] };

    const [from, setFrom] = React.useState<string>(fromFilterValue.Values[0]);
    const [to, setTo] = React.useState<string>(toFilterValue.Values[0]);

    return (<NumberRangeModal
        header={header + ' Filter'}
        show={true}
        to={to}
        from={from}
        onChange={(_from, _to) => {
            setFrom(_from);
            setTo(_to);
        }}
        onClose={() => {
            onClose(
                [
                    { Member: member, Condition: QueryCondition.GreaterThanOrEqual, Values: !!from ? [from] : [] },
                    { Member: member, Condition: QueryCondition.LessThanOrEqual, Values: !!to ? [to] : [] }
                ]
            );
        }}
        onClear={() => {
            onClear(member);
        }}
    />)
}
